export const PROFILE_THEME_FONT_OPTIONS = [
  { value: "Inter", label: "Modern · Inter" },
  { value: "Poppins", label: "Modern · Poppins" },
  { value: "Playfair Display", label: "Elegant · Playfair" },
  { value: "Lato", label: "Minimal · Lato" },
  { value: "Merriweather", label: "Classic · Merriweather" },
  { value: "Montserrat", label: "Bold · Montserrat" },
  // Fonts pros bring over from Acuity booking pages.
  { value: "Roboto Condensed", label: "Compact · Roboto Condensed" },
  { value: "Raleway", label: "Elegant · Raleway" },
  { value: "Lora", label: "Warm · Lora" },
  { value: "Oswald", label: "Striking · Oswald" },
];

export const PROFILE_THEME_OFFERED_FONTS = PROFILE_THEME_FONT_OPTIONS.map(
  (option) => option.value
);

export const PROFILE_THEME_LEGACY_FONTS = [
  "Arial",
  "Helvetica",
  "Roboto",
  "Open Sans",
  "Times New Roman",
];

export const PROFILE_THEME_SUPPORTED_FONTS = [
  ...PROFILE_THEME_OFFERED_FONTS,
  ...PROFILE_THEME_LEGACY_FONTS,
];

export const PROFILE_THEME_FONT_STACKS = {
  Inter: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif",
  Poppins: "'Poppins', system-ui, -apple-system, 'Segoe UI', sans-serif",
  "Playfair Display": "'Playfair Display', Georgia, 'Times New Roman', serif",
  Lato: "'Lato', system-ui, -apple-system, 'Segoe UI', sans-serif",
  Merriweather: "'Merriweather', Georgia, 'Times New Roman', serif",
  Montserrat:
    "'Montserrat', 'Avenir Next', 'Segoe UI', system-ui, -apple-system, sans-serif",
  "Roboto Condensed":
    "'Roboto Condensed', 'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
  Raleway: "'Raleway', 'Helvetica Neue', system-ui, -apple-system, 'Segoe UI', sans-serif",
  Lora: "'Lora', Georgia, 'Times New Roman', serif",
  Oswald: "'Oswald', 'Arial Narrow', 'Helvetica Neue', Arial, sans-serif",
  Arial: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
  Helvetica: "Helvetica, Arial, 'Helvetica Neue', sans-serif",
  Roboto: "'Roboto', 'Segoe UI', system-ui, -apple-system, sans-serif",
  "Open Sans": "'Open Sans', 'Segoe UI', system-ui, -apple-system, sans-serif",
  "Times New Roman": "'Times New Roman', Times, serif",
};

// The Google Fonts `family=` value for each offered font. A booking page loads
// only the one it uses (utils/profileThemeFontLoader.js). Legacy fonts have no
// entry: they are system fonts, or Open Sans, which index.css loads for the app.
export const PROFILE_THEME_GOOGLE_FONT_FAMILIES = {
  Inter: "Inter:wght@400;600;700",
  Poppins: "Poppins:wght@400;500;600;700",
  "Playfair Display": "Playfair+Display:wght@400;600;700",
  Lato: "Lato:wght@400;700",
  Merriweather: "Merriweather:wght@400;600;700",
  Montserrat: "Montserrat:wght@400;500;600;700",
  "Roboto Condensed": "Roboto+Condensed:wght@400;500;600;700",
  Raleway: "Raleway:wght@400;500;600;700",
  Lora: "Lora:wght@400;500;600;700",
  Oswald: "Oswald:wght@400;500;600;700",
};

// Same fallback as resolveProfileThemeFontFamily: anything we don't know is Inter.
export const resolveProfileThemeFontName = (fontName) =>
  Object.prototype.hasOwnProperty.call(PROFILE_THEME_FONT_STACKS, fontName)
    ? fontName
    : "Inter";

export const resolveProfileThemeFontFamily = (fontName) =>
  PROFILE_THEME_FONT_STACKS[resolveProfileThemeFontName(fontName)];

export const getProfileThemeFontStylesheetUrl = (fontName) => {
  const family = PROFILE_THEME_GOOGLE_FONT_FAMILIES[resolveProfileThemeFontName(fontName)];
  return family
    ? `https://fonts.googleapis.com/css2?family=${family}&display=swap`
    : null;
};

export const isSupportedProfileThemeFont = (fontName) =>
  PROFILE_THEME_SUPPORTED_FONTS.includes(fontName);
